import React from 'react';
import Footer from '../components/Footer';
import NavBar from '../components/NavBar';

export default class GizlilikPage extends React.Component {

    constructor() {
        super();
    }

    render() {
        return <><NavBar /><div style={{display:"flex", paddingTop:200,flexDirection:"column"}}>

            <div style={{paddingLeft:"15%", paddingRight:"15%", paddingBottom:200}}>
                <p style={{fontSize:32, lineHeight:"40px", fontWeight:"500",textAlign:"center"}}>Gizlilik Politikası</p>
                
                <p style={{marginTop:50, textAlign:"justify",color:"#333c4e", fontFamily:"arial", }}>
                {`ÇEREZ POLİTİKASI
 

 Taşımacım (https://tasimacim.com) olarak internet sitelerimizden en verimli şekilde faydalanabilmeniz ve kullanıcı deneyiminizi geliştirebilmek için çerezler (cookies) kullanıyoruz. Çerez kullanımını tercih etmezseniz tarayıcınızın ayarlarından cookie’leri silebilir ya da engelleyebilirsiniz. Ancak bunun internet sitelerimizin kullanımınızı etkileyebileceğini unutmamalısınız.
 
 Tarayıcınızdan cookie ayarlarınızı değiştirmediğiniz sürece internet sitelerimizde çerez kullanımını kabul ettiğinizi varsayacağız. Toplanan verilerle ilgili düzenlemelere internet sitelerimizde yer alan “Gizlilik Politikası Metni”nden ulaşabilirsiniz.
 
  
 
 Çerez Nedir ve Neden Kullanılmaktadır?
  
 Çerezler, bir bilgisayar ağını kullanırken bilgisayarınızı tanımlamak için kullanılan kullanıcı veri parçaları içeren metin dosyalarıdır. HTTP tanımlama bilgileri olarak bilinen belirli tanımlama bilgileri, belirli kullanıcıları tanımlamak ve web'de gezinme deneyiminizi geliştirmek için kullanılır.
 
  
 
 Bir çerezde saklanan veriler, bağlantınız üzerine sunucu tarafından oluşturulur. Bu veriler size ve bilgisayarınıza özel bir kimlikle etiketlenir.
 
  
 
 Çerez, bilgisayarınız ve ağ sunucusu arasında değiş tokuş edildiğinde, sunucu kimliği okur ve size özel olarak hangi bilgileri sunacağını bilir.
 
  
 
 Daha detaylı bilgi için: http://www.aboutcookies.org/ ve http://www.allaboutcookies.org/ adreslerini ziyaret edebilirsiniz.
 
  
 
 Sitemizde çerez kullanılmasının başlıca amaçları internet sitemizin işlevselliğini ve performansını arttırmak yoluyla sizlere sunulan hizmetleri geliştirmek, internet sitelerimizi iyileştirmek ve platform üzerinden yeni özellikler sunmak ve sunulan özellikleri sizlerin tercihlerine göre kişiselleştirmektir. Ayrıca internet sitemizin, sizin ve Taşımacım (https://tasimacim.com) internet sitemizin hukuki ve ticari güvenliğinin teminini sağlamaktır.
 
  
 
 Web Sitemizde Kullanılan Çerezler Türleri
  
 Oturum Çerezleri (Session Cookies)
 
  
 
 Oturum çerezleri ziyaretçilerimizin web sitesini ziyaretleri süresince kullanılan, tarayıcı kapatıldıktan sonra silinen geçici çerezlerdir. Bu tür çerezlerin kullanılmasının temel amacı ziyaretiniz süresince İnternet Sitesinin düzgün bir biçimde çalışmasının teminini sağlamaktır.
 
  
 
 Örneğin; birden fazla sayfadan oluşan çevrimiçi formlar.
 
  
 
 Kalıcı Çerezler (Persistent Cookies)
 
  
 
 Kalıcı çerezler web sitesinin işlevselliğini artırmak, ziyaretçilerimize daha hızlı ve iyi bir hizmet sunmak amacıyla kullanılan çerez türleridir. Bu tür çerezler tercihlerinizi hatırlamak için kullanılır ve tarayıcılar vasıtasıyla cihazınızda depolanır.
 
  
 
 Kalıcı çerezlerin bazı türleri; web sitesini kullanım amacınız gibi hususlar göz önünde bulundurarak sizlere özel öneriler sunulması amacıyla kullanılabilmektedir. Kalıcı çerezler sayesinde web sitemizi aynı cihazla tekrardan ziyaret etmeniz durumunda, cihazınızda web sitemiz tarafından oluşturulmuş bir çerez olup olmadığı kontrol edilir ve var ise, sizin siteyi daha önce ziyaret ettiğiniz anlaşılır ve size iletilecek içerik bu doğrultuda belirlenir ve böylelikle sizlere daha iyi bir hizmet sunulmuş olur.
 
  
 
 İnternet Sitelerimizde Kullanılan Çerezlerin Kategorileri
  
 
 Teknik Çerezler (Technical Cookies)
 
  
 
 Teknik çerezler ile web sitesinin çalışmasının sağlayarak çalışmayan sayfaları ve alanları tespit edilmesi üzerine çalışır.
 
  
 
 Doğrulama Çerezleri (Authentication Cookies)
 
  
 
 Ziyaretçiler, şifrelerini kullanarak web sitesine giriş yapmaları durumunda, bu tür çerezler ile ziyaretçinin web sitesinde ziyaret ettiği her bir sayfada site kullanıcısı olduğu belirlenerek, kullanıcının her sayfada şifresini yeniden girmesi önlenir.
 
  
 
 Kişiselleştirme Çerezleri (Customization Cookies)
 
  
 
 Kullanıcıların tercihlerini farklı web sitesinin farklı sayfalarını ziyarette de hatırlamak için kullanılan çerezlerdir. Örneğin, seçmiş olduğunuz dil tercihinizin hatırlanması, vb.
 
  
 
 Analitik Çerezler (Analytical Cookies)
 
  
 
 Analitik çerezler ile web sitesini ziyaret edenlerin sayıları, web sitesinde görüntülenen sayfaların tespiti, web sitesi ziyaret saatleri, web sitesi sayfaları kaydırma hareketleri gibi analitik sonuçların üretimini sağlayan çerezlerdir.
 
  
 
  
  
 Taşımacım (https://tasimacim.com)’da Kullanılan Çerezler
  
 Reklam: Davranışsal ve hedef odaklı reklamların ziyaretçilere gösterilmesi amacıyla kullanılmaktadır. 3 ayrı tarayıcı ayarları aracığıyla kabul etmek ya da reddetmek mümkünüdür.
 
  
 
 Facebook: Bu tür çerezler, Facebook üyelerinin (veya üye olmayan kişilerin) pazar analizi ve ürün gelişimi amacıyla izlenmesini sağlar. Çerezin ilk kurulumundan itibaren 2 yıl. Tarayıcı ayarları aracığıyla kabul etmek ya da reddetmek mümkünüdür.
 
  
 
 Google Analitikleri: Bu tür çerezler tüm istatistiksel verilerin toplanmasını bu şekilde sitenin sunumunun ve kullanımının geliştirilmesini sağlar. Google, bu istatistiklere evrensel istatistikler ve ilgililere ilişkin veriler eklemek suretiyle, kullanıcıları daha iyi anlamamızı sağlar.
 
  
 
 Web sitemiz, Google Analitik çerezleri kullanmaktadır. Söz konusu çerezler ile toplanan veriler, ABD’de bulunan Google sunucularına aktarılmakta ve söz konusu veriler Google’ın veri koruma ilkeleri ile uyumlu olarak muhafaza edilmektedir.
 
  
 
 Google’ın analitik veri işleme faaliyetleri ve kişisel verilerin korunması konusundaki ilkeler hakkında daha fazla bilgi sahibi olmak için burayı tıklayabilirsiniz. Son güncellemeden itibaren 2 yıl. Çerezlerin Kontrolü https://tools.google.com/dlpaqe/gaoptout
 
  
 
 Oturum: Oturum çerezleri oturumun sürekliliğinin sağlanması amacıyla kullanılır. İlk kurulumundan itibaren 82 yıl. Tarayıcı ayarları aracığıyla kabul etmek ya da reddetmek mümkündür.
 
  
 
 Kişiselleştirme Çerezleri (Dil): Kullanıcının seçtiği dili kaydeder ve buna uygun seçenekler sunar. Sınırsız, tarayıcıdan ayar/silme yapılana kadar bilgisayarda kalır. Tarayıcı ayarları aracığıyla kabul etmek ya da reddetmek mümkündür.
 
  
 
 Eğer kullanıcı siteyi mobil bir cihazdan ziyaret ediyorsa, ana web sitesini göstermek için kullanılır. Kaynak site kullanıcının tercihlerinin daha iyi anlaşılabilmesi için kaydedilir. Oturum Çerezi Tarayıcı ayarları aracığıyla kabul etmek ya da reddetmek mümkündür.
 
  
 
 Çerezlerin Kullanımı Veri Sahipleri Tarafından Engellenebilir mi?
  
 
 Tarayıcınızın ayarlarını değiştirerek çerezlere ilişkin tercihlerinizi kişiselleştirme imkanına sahipsiniz.
 
  
 
 Google Analytics
 
 https://tools.google.com/dlpage/gaoptout
 
  
 
 Google Chrome
 https://www.google.com/support/chrome/bin/answer.py?hl=en&answer=95647
 
  
 
  
 
 Mozilla Firefox
 https://support.mozilla.com/en-US/kb/Cookies
 
  
 
 Opera
 https://www.opera.com/browser/tutorials/security/privacy/
 
  
 
 Safari
 https://support.apple.com/kb/ph19214?locale=tr_TR
 
  
 
 Çerez Politikası’ndaki Değişiklikler
  
 İşbu Çerez Politikası değişen şartlara ve mevzuata uyum sağlamak amacıyla zaman zaman değişen yasal mevzuatlar ışığında Taşımacım (https://tasimacim.com) tarafından güncellenecektir. Kullanıcı çerez politikasını zaman zaman kontrol ederek, değişimler konusunda bilgi sahibi olmalıdır.
 
  
 
  
  
  
  
  
  
  
  
  
  
  
  
 KVKK AYDINLATMA METNİ
  
 
 İşbu Kişisel Veriler Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“Kanun”) uyarınca kişisel verilerinizin toplanması, işlenmesi, aktarılması ve Kanun kapsamındaki haklarınıza dair sizleri bilgilendirmek amacıyla hazırlanmıştır.
 
  
 
 (Adres yazılacak) adresinde mukim Taşımacım Nakliyat Lojistik Aracılık Hizmetleri Ltd. Şti. Şirketi (“Şirketimiz” veya “Taşımacım (https://tasimacim.com)”) olarak, veri sorumlusu sıfatıyla kişisel verilerinizi Kanun ve ilgili mevzuata uygun olarak aşağıda açıklanan kapsamda işliyoruz.
 
  
 
 İşlediğimiz Kişisel Veriler
  
 İşbu Aydınlatma Metni’nde belirtilen kişisel veri işleme amaçlarımızı gerçekleştirebilmek amacıyla aşağıdaki kişisel verilerini işliyoruz:
 
  
 
 ·         Ad, soyad, T.C. Kimlik numarası, kimlik belgesinde yer alan diğer bilgiler, ehliyet fotokopisinde yer alan bilgiler dahil kimlik bilgileriniz;
 
 ·         E-posta, telefon numarası, cep telefonu, ev ve iş yeri adresi dahil iletişim bilgileriniz;
 
 ·         Aile ve yakınlarınız ile ilgili bilgiler;
 
 ·         Mobil uygulama veya internet sitesi ziyaretiniz üzerinden konum bilgileriniz,
 
 ·         Özlük bilgileriniz;
 
 ·         Hukuki işlem bilgileriniz;
 
 ·         Müşteri işlem bilgileriniz;
 
 ·         Ziyaretçi giriş ve çıkış kayıtları dahil fiziksel mekân güvenliği bilgileriniz;
 
 ·         IP adresi ve internet sitesi giriş çıkış bilgileri dahil işlem güvenliği bilgileriniz;
 
 ·         Risk yönetimi bilgileriniz;
 
 ·         Banka kartı ve kredi kartı bilgileriniz dahil finansal bilgileriniz;
 
 ·         CV'leriniz ve özgeçmiş bilgileriniz dahil mesleki deneyim bilgileriniz;
 
 ·         Kullanım alışkanlıklarınız ve geçmiş ürün/hizmet alımı bilgileriniz dahil pazarlama bilgileriniz;
 
 ·         Görsel ve işitsel verileriniz,
 
 ·         CV’lerinizde yer alan dernek ve vakıf üyeliği bilgileriniz,
 
 ·         Ehliyet fotokopilerinde yer alan kan grubu bilgileriniz.
 
  
 
 Kişisel Veri İşleme Amaçları
  
 Kişisel verilerinizi, aşağıdaki amaçlar ile sınırlı olarak işliyoruz:
 
  
 
 ·         Ürün ve/veya hizmetlerimizin sunulabilmesi ve satış süreçlerinin yürütülmesi,
 
 ·         Ürün ve/veya hizmet alım süreçlerinin yürütülmesi,
 
 ·         İhtiyaçlarınız ve talepleriniz doğrultusunda ürün ve hizmetlerimizin güncellenmesi, özelleştirilmesi ve geliştirilmesi
 
 ·         Ürün ve hizmetlerimizdeki problemlerin çözülmesi, hata, sorun ve bugların tespit edilmesi ve bunların giderilmesi,
 
 ·         Yeni ürün veya hizmetlerimiz, mevcut ürün veya hizmetlerimizdeki değişiklikler ile kampanyalarımız ve promosyonlarımız hakkında sizlerin bilgilendirilmesi,
 
 ·         Ürün ve hizmetlerimiz hakkında size gerekli eğitimlerin ve bilgilendirmelerin verilebilmesi, programlarımızın nasıl kullanılacağının izah edilmesi,
 
 ·         Müşteri ilişkileri süreçlerinin yürütülmesi,
 
 ·         Çağrı merkezi ve uzaktan destek hizmetlerinin sağlanması,
 
 ·         İnternet sitesi üyelik işlemlerinin gerçekleştirilmesi,
 
 ·         İnternet sitelerimizde ziyaretçilerimizin tecrübesini iyileştirmek, talep ve sorunları tespit etmek ve aramalarını hızlı sonuçlandırmak amacıyla çerezlerin yönetilmesi. (Daha detaylı bilgi için Çerez Politikamıza bakabilirsiniz)
 
 ·         Ticari faaliyetlerimizi yürütmeye devam etmek amacıyla iletişim bilgilerinizin güncellenmesi ve bu güncel bilgilerinizin ilgili kurumlarımız, şirketlerimiz, yüklenicilerimiz ve/veya tedarikçilerimize sağlanması,
 
 ·         İş süreçlerinizi analiz ederek, ürün ve hizmetlerimizin süreçlerinize uygun olarak hale getirilmesi ve önerileriniz, istekleriniz ya da raporlarımız doğrultusunda iyileştirilmesi, tarafınızca yapılan herhangi bir şikâyetin incelenmesi ve yanıtlanması,
 
 ·         Yanlış ödeme yapanlara ödemenin iadesi işlemlerinin yürütülmesi,
 
 ·         Müşteri memnuniyetine yönelik aktivitelerin yürütülmesi, sosyal medya ve iletişim süreçlerinin planlanması ve icra edilmesi,
 
 ·         Pazarlama faaliyetlerinin yürütülmesi, reklam / kampanya / promosyon süreçlerinin yürütülmesi,
 
 ·         Cari kaydının açılması ve kaydının güncellenmesi ve müşteri ve iş ortaklarının nevi, unvan ve tür değişikliğinin yapılması,
 
 ·         İş ortağı memnuniyetinin sorgulanması,
 
 ·         İş faaliyetlerimizin yönetilmesi, yürütülmesi ve denetlenmesi, iş sürekliliğinin sağlanması faaliyetlerinin yürütülmesi,
 
 ·         Finans ve muhasebe işlerinin yürütülmesi,
 
 ·         Bina ve tesislerimizin fiziksel mekân güvenliğinin sağlanması ve ziyaretçi kayıtlarının oluşturulması ve takibinin sağlanması,
 
 ·         Yazılımlarımızın ve sistemlerimizin güvenliğinin sağlanması ve bilgi güvenliği süreçlerinin yürütülmesi,
 
 ·         Çalışanlarımızın yakınları için yan haklar ve menfaatler sağlanması,
 
 ·         Çalışan adaylarının iş başvurularının değerlendirilmesi, mülakatların ve görüşmelerin yapılması, özgeçmişlerinde referans olarak gösterdikleri kişiler ile iletişime geçilmesi,
 
 ·         Şirket satın alımıyla ilgili süreçlerin yürütülmesi,
 
 ·         Şirketimiz tarafından ticari kredi kartlarının çıkarılması,
 
 ·         Yasal mevzuatlara uyum sağlanmak ve hukuki yükümlülüklerimizin yerine getirilmesi.
 
  
 
 Kişisel Verileri Toplama Yöntemi
  
 Kişisel verilerinizi, aşağıda belirtilen otomatik ve otomatik olmayan kanallar üzerinden topluyoruz:
 
  
 
 ·         CCTV (Kapalı Devre Kamera Kayıtları),
 
 ·         Çerezler (Cookies) ve benzer takip teknolojileri,
 
 ·         Matbu ve elektronik form,
 
 ·         Posta, kargo ya da kurye hizmetleri,
 
 ·         Uzaktan erişim sağlayan programlar,
 
 ·         Türkiye’nin farklı yerlerindeki bayilerimiz, iş ortaklarımız,
 
 ·         Hizmet aldığımız firmalar,
 
 ·         Diğer fiziki ve elektronik ortamlar,
 
  
 
 1.     İşlemeye Yönelik Hukuki Sebeplerimiz
  
 Kişisel verilerinizi, Kanun’un 5. ve 6. maddelerinde belirtilen işleme şartları dahilinde işliyoruz.
 
  
 
 2.     Kişisel Verilerinizin Aktarılması
  
 Kişisel verilerinizi Kanun’un 8. ve 9. maddelerinde belirtilen işleme şartları dahilinde, yukarıda belirttiğimiz amaçlar ile sınırlı olarak çalışanlarımız, iş ortaklarımız, hissedarlarımız, tedarikçilerimiz, şirket temsilcisi ve hukuken yetkili vekillerimiz ve hukuken yetkili kamu/özel kurum ve kuruluşlarına aktarabiliyoruz.
 
  
 
 3.     Kişisel Verilerinize İlişkin Haklarınız
  
 Kanun’un 11. maddesi uyarınca kişisel verilerinize ilişkin aşağıdaki haklara sahipsiniz:
 
  
 
 ·         Kişisel verilerinizin işlenip işlenmediğini öğrenme,
 
 ·         Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,
 
 ·         Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,
 
 ·         Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,
 
 ·         Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,
 
 ·         6698 sayılı Kişisel Verilerin Korunması Kanunu ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerinizin silinmesini veya yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,
 
 ·         İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,
 
 ·         Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde bu zararın giderilmesini talep etme.
 
  
 
 Bu haklarınıza ilişkin taleplerinizi internet sitemizdeki Başvuru Formu üzerinden gönderebilirsiniz.
 
  
 
 Başvurunuz ücretsiz olarak yerine getirilecektir. Ancak talep edilen işlemin ayrıca bir maliyet gerektirmesi halinde, Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifedeki ücretler başvurandan talep edilecektir.
 
  
 
  
 
  
 
  
 
  
 
  
 
  
 
  
 
  
 
  
 
  
 
  
 
  
 
  
 
  
 
  
 
 TAŞIMACIM (https://tasimacim.com) TİCARİ ELEKTRONİK İLETİ GÖNDERİLMESİNE İŞLENMESİNE İLİŞKİN AYDINLATMA METNİ
 
  
 
 İşbu döküman 6698 sayılı Kişisel Verilerin Korunması Kanunu’nun (“KVK Kanunu”) 10.maddesi ile Aydınlatma Yükümlülüğünün Yerine Getirilmesinde Uyulacak Usul ve Esaslar Hakkında Tebliğ uyarınca kişisel verilerinizin işlenmesi konusunda aydınlatılmanızı sağlamak amacıyla hazırlanmıştır
 
  
 
 (Adres yazılacak) adresinde mukim TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. Şirketi (“Şirketimiz” veya “Taşımacım (https://tasimacim.com)”) (“Şirketimiz” veya “Taşımacım (https://tasimacim.com)”) olarak veri sorumlusu sıfatıyla kişisel verilerinizi, KVK Kanunu ve ilgili mevzuata uygun olarak aşağıda açıklanan kapsamda işlenmektedir.
 
  
 
 Kişisel Verilerinizi İşleme Amaçları
 
  
 
 Kişisel verileriniz amaçla bağlılık ilkesi uyarınca sınırlı, ölçülü, belirli, açık ve meşru amaçlarla, hukuka ve dürüstlük kurallarına uygun şekilde işlenmektedir. Ayrıca Şirketimiz, işlediği kişisel verilerin doğru ve güncel tutulması için gerekli özeni göstermektedir. Bu bağlamda kişisel verileriniz aşağıdaki amaçlarla işlenebilmektedir.
 
  
 
 Şirketimiz, yürüttüğü faaliyetlerin bazılarında ise kişisel verilerinizi işlerken sizlerin açık rızasına ihtiyaç duyabilmektedir. Şirketimizin müşterilerimize ve potansiyel müşterilerimize sunduğu ürün ve hizmetlerin pazarlama süreçlerinin yürütülmesi ve en yüksek faydayı elde etmeniz için planlamalar yapılması, ürün ve hizmetlerimize yönelik size özel imkanlarının duyurulması, tanıtım ve reklam faaliyetlerinin yürütülmesi, müşteri memnuniyeti ve bağlılığı çalışmalarının yönetilmesi gibi amaçlarla kimlik bilgilerinizi, iletişim bilgilerinizi ve pazarlama bilgilerinizi işleyebilmekteyiz.
 
  
 
 Kişisel Verilerinizin Aktarılması
 
  
 
 Kişisel verileriniz amaçla bağlılık ilkesi uyarınca sınırlı, ölçülü, belirli, açık ve meşru amaçlarla, hukuka ve dürüstlük kurallarına uygun şekilde işlenmektedir. Ayrıca Şirketimiz, işlediği kişisel verilerin doğru ve güncel tutulması için gerekli özeni göstermektedir. Bu bağlamda kişisel verileriniz aşağıdaki amaçlarla işlenebilmektedir. Başta iletişim bilgileri olmak üzere kişisel verileriniz, işin yürütülmesinin sağlanması amacı ve yukarıda belirtilen amaçlar dahilinde hizmet aldığımız tedarikçilerimiz ve iş ortaklarımızla ve kanunlarda öngörülen nedenlerle hukuki yükümlülüklerimizi yerine getirmek amacıyla yetkili kamu kurumlarına ve özel kişilere aktarılabilecektir.
 
  
 
 Kişisel Verilerinizi Toplama Yöntemi ve Hukuki Sebebi
 
  
 
 KVK Kanunu 5/1 maddesinde belirtilen açık rızasınız bulunması ve KVK Kanunu 5/2(d) maddesinde belirtilen ilgili kişinin kendisi tarafından alenileştirilmiş olması hukuki sebeplerine dayanarak Şirketimiz, kişisel verilerinizi e-posta, telefon, SMS ve diğer cihazlar dahil olmak üzere fiziki ve elektronik ortamlar üzerinden yukarıda belirtilen amaçların en pratik ve etkin bir şekilde yerine getirilmesi amacıyla toplamaktadır.
 
  
 
 Kişisel Verilerinizin Saklanması
 
  
 
 Kişisel verileriniz, işlenme amaçlarının gerektirdiği süreler boyunca saklanabilmektedir. KVK Kanunu madde 5/2(ç) şirketin hukuki yükümlülüğünü yerine getirmesi kapsamında Şirketimiz, iş ortaklarımız ve tedarikçilerimiz, ticari elektronik ileti almayı veya ticari elektronik iletişimi reddetmeniz durumunda, kişisel verilerinizi ret tarihinden itibaren daha uzun sürelerce saklanmasını gerektiren bir sebebin olmaması halinde 3 yıl boyunca saklayabilmektedir. Başka bir gerekçe veya hukuki sebep olmaması, herhangi bir mevzuatta öngörülen yasal saklama süresi bulunmaması, uluslararası yasa veya düzenlemenin bulunmaması ve sözleşmelerden kaynaklı zorunlulukların ortadan kalkması hallerinde işlenme amaçları ortadan kalkan kişisel verileriniz silinmekte, yok edilmekte veya anonim hale getirilmektedir.
 
  
 
 Kişisel Verilerinize İlişkin Haklarınız
 
  
 
 Kişisel veri sahibi olarak, KVK Kanunu’nun 11. maddesi uyarınca kişisel verilerinize ilişkin aşağıdaki haklara sahipsiniz:
 
  
 
 ·         Kişisel verilerinizin işlenip işlenmediğini öğrenme,
 
 ·         Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,
 
 ·         Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,
 
 ·         Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,
 
 ·         Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,
 
 ·         6698 sayılı Kanun ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerinizin silinmesini veya yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,
 
 ·         İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,
 
 ·         Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde bu zararın giderilmesini talep etme
 
  
 
 Bu haklarınıza ilişkin taleplerinizi internet sitemizdeki Başvuru Formunu doldurarak iletebilirsiniz. Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ uyarınca bulunması zorunlu hususlara yer vererek, yazılı veya kayıtlı elektronik posta (KEP) adresi, güvenli elektronik imza, mobil imza ya da tarafınızdan Şirketimize daha önce bildirilen ve Şirketimizin sisteminde kayıtlı bulunan elektronik posta adresinizi kullanmak suretiyle Şirketimize iletebilirsiniz. Başvurunuz ücretsiz olarak yanıtlanacaktır. Ancak talep edilen işlemin ayrıca bir maliyet gerektirmesi halinde, Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifedeki ücretler başvurandan talep edilecektir.
 
  
 
 TİCARİ ELEKTRONİK İLETİ GÖNDERİLMESİNE İŞLENMESİNE İLİŞKİN AYDINLATMA METNİ
  
 
 Açık rızanız kapsamında, şirketimizin sunduğu ürün ve hizmetlerin pazarlama süreçlerinin yürütülmesi ve en yüksek faydayı elde etmeniz için planlamalar yapılması, ürün ve hizmetlerimize yönelik size özel imkanların tarafınıza sunulması, tanıtım ve reklam faaliyetlerinin yürütülmesi gibi amaçlarla kişisel verilerinizi işleyebilmekteyiz.
 
  
 
 İş faaliyetlerinin yürütülmesi ve iş sözleşmesinin gerektirmesi halinde kişisel verileriniz yurtiçinde veya yurtdışındaki hizmet aldığımız üçüncü kişi firmalarla paylaşılabilmektedir.
 
  
 
 İşbu metin, 6563 Elektronik Ticaretin Düzenlenmesi Hakkında Kanun ve Ticari İletişim ve Ticari Elektronik İletiler Hakkında Yönetmelik kapsamında TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. Taşımacım (https://tasimacim.com tarafından sunulan ürün ve hizmetlerin hakkında genel/özel imkanların duyurulmasına, güncel gelişmelerden haberdar edilmesine, kutlama amaçlı iletiler gönderilmesine, sunum ve bülten gibi içeriklerin paylaşılmasına, tanıtım ve reklamının yapılması için tarafıma ilgili kanunlara uygun olarak ticari elektronik ileti ve diğer iletiler gönderilmesine, iletişim bilgilerimin, kimlik bilgilerimin, pazarlama bilgilerimin mal / hizmet satış ve reklam / kampanya/ promosyon süreçlerinin yürütülmesi adına bu amaçlar ile alındığına ve tercih ettiğim kanalla tarafıma iletiler gönderileceğine, her zaman iletişim tercihlerimi değiştirebileceğime veya hiçbir gerekçe göstermeksizin tarafıma gelen iletilerde belirtilen işlemi reddederek iletişimi durdurabileceğime ve kanunlara uygun şekilde SMS/kısa mesaj, otomatik arama, telefonla arama, sosyal medya ile çevrimiçi reklam ağları, e-posta/mail ve diğer elektronik iletişim araçları-kanalları yoluyla tarafıma ticari elektronik iletiler ve diğer iletiler gönderilmesine ilişkin onayımı içermektedir.
 
  
 
 Tarafıma gönderilecek ticari elektronik iletilere ilişkin yukarıdaki Aydınlatma ve Açık Rıza Metni’ni ve işbu metni okuduğumu ve anladığımı kabul ve beyan ediyorum. Bu kapsamda aşağıda tercih ettiğim kanallarla tarafıma ticari elektronik ileti gönderilmesine açık rıza ve onay veriyorum.
 
  
 GİZLİLİK POLİTİKASI
  
 
 İşbu Gizlilik Politikası ile kişisel verilerinizin işlenmesi hakkında aydınlatılmış olduğunuzu ve kişisel verilerinizin burada belirtilen şekilde kullanılmasına onay verdiğinizi kabul etmektesiniz.
 
  
 
 İşbu Gizlilik Politikası’nda TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. Şirketi. tarafından işletilmekte olan https://tasimacim.com/ internet sitesi (“Site”) / mobil uygulama işletilmesi sırasında Site/Mobil uygulama kullanıcıları/üyeleri/ziyaretçileri (“Veri Sahibi”) tarafından TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. ile paylaşılan veya TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. Veri Sahibi’nin Site’nin kullanımı sırasında ürettiği kişisel verilerin kullanımına ilişkin koşul ve şartlara yer verilmiştir.
 
 Hangi Verilerinizi İşliyoruz?
  
 
 TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. işlediği kişisel verileriniz aşağıda belirtilen şekilde Kişisel Verilerin Korunması Kanunu’na (Kanun) uygun olarak kategorize edilmiştir. Aksi açıkça belirtilmedikçe, işbu Gizlilik Politikası kapsamında arz edilen hüküm ve koşullar kapsamında “kişisel veri” ifadesi aşağıda yer alan bilgileri kapsayacaktır.
 
  
 
 Lokasyon Bilgisi
 
  
 
 TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. hizmetlerini kullanmanız esnasında elde etmiş olduğumuz, GPS verisi gibi konumunuza ilişkin belirli veya yaklaşık konum bilgileri
 
  
 
 İşlem Güvenliği Bilgisi
 
  
 
 Log in credential bilgileri, parola bilgileri
 
  
 
 Pazarlama Bilgisi
 
  
 
 Alışkanlıklarınız ile beğenilerinizi gösteren raporlar ve değerlendirmeler, hedefleme bilgileri, çerez (cookie) kayıtları vb. bilgiler
 
  
 
 Talep/Şikâyet Yönetimi Bilgisi
 
  
 
 Site üzerinden yaptığınız talep ve şikayetler ile Site ’de paylaştığınız yorumlarınız
 
  
 
 Risk Yönetimi Bilgisi
 
  
 
 IP adresi Kanunun 3. ve 7. maddeleri çerçeve anonim hale getirilen veriler, anılan kanun hükümleri uyarınca kişisel veri olarak kabul edilmeyecek ve bu verilere ilişkin işleme faaliyetleri işbu Gizlilik Politikası hükümleri ile bağlı olmaksızın gerçekleştirecektir. Verilerinizin işlenip işlenmediği konusunda başvuru konusunda bkz. TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ.
 
  
 
 Verilerinizin Kullanım Amacı Nedir?
  
 TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. ile paylaştığınız kişisel verileriniz, Site ’den ve Site üzerinden veya Mobil uygulama üzerinden sağlanan hizmetlerden faydalanabilmeniz için, Site ’ye üyelik kaydınızın gerçekleştirilmesi, üyelik kaydına ilişkin güncellemelerin yapılması, TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. sunduğu ve Site üzerinden sunulan hizmetlerin iyileştirilmesi yeni hizmetlerin tanıtılması ve bu doğrultuda tarafınıza gerekli bilgilendirmelerin yapılması ve uygulanması, TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. ve TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. ile iş ilişkisi içinde olan kişilerin hukuki ve ticari güvenliğinin temininin sağlanması ve bu kapsamda tarafınıza gerekli bilgilendirilmelerin yapılması ve bu faaliyetlerin doğasından kaynaklanan yükümlülüklerin yerine getirilmesi için işlenebilir.
 
  
 
 Söz konusu kişisel bilgiler sizinle iletişime geçmek veya Site ’deki veya Mobil uygulama üzerindeki deneyiminizi iyileştirmek (iletişim yönetimi sürecinin yönetilmesi, memnuniyet araştırmalarının yapılması vb.) amacıyla kullanılabileceği gibi, şirket içi raporlama ve iş geliştirme faaliyetleri kapsamında kullanılabilecek, kimliğiniz ifşa edilmeksizin çeşitli istatistiksel değerlendirmeler yapma ve veri tabanı oluşturma amacıyla da kullanılabilecektir. Söz konusu bilgiler TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. tarafından profilleme ve analiz amaçlarıyla işlenebilecek, saklanabilecek, üçüncü kişilere iletilebilecek ve söz konusu bilgiler üzerinden çeşitli uygulama, ürün ve hizmetlerin tanıtımı, bakım ve destek faaliyetlerine ilişkin bildirimlerde bulunma amacıyla sizlerle ile iletişime geçilebilecektir. TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. ayrıca, Kanunu’nun 5 ve 8. maddeleri uyarınca ve/veya ilgili mevzuattaki istisnaların varlığı halinde kişisel verileri Veri Sahibi olarak sizlerin ayrıca rızasını almaksızın işleyebilecek ve üçüncü kişilerle paylaşabilecektir. Bu durumların başlıcaları aşağıda belirtilmiştir: içerik bu doğrultuda belirlenir ve böylelikle sizlere daha iyi bir hizmet sunulur.
 
  
 
 ·         Kanunlarda açıkça öngörülmesi,
 
 ·         Fiili imkânsızlık nedeniyle rızasını açıklayamayacak durumda bulunan veya rızasına hukuki geçerlilik tanınmayan kişinin kendisinin ya da bir başkasının hayatı veya beden bütünlüğünün korunması için zorunlu olması,
 
 ·         Veri Sahibi ile TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. arasında herhangi bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması kaydıyla, kişisel verilerin işlenmesinin gerekli olması,
 
 ·         TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. hukuki yükümlülüklerini yerine getirebilmesi için zorunlu olması,
 
 ·         Veri Sahibi’nin kendisi tarafından alenileştirilmiş olması,
 
 ·         Bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması,
 
 ·         Veri Sahibi’nin temel hak ve özgürlüklerine zarar vermemek kaydıyla TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. meşru menfaatleri için veri işlenmesinin zorunlu olması.
 
  
 
 Yukarıda da belirtildiği üzere TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. , çerez (Cookie) kullanabilecek ve bu kapsamda veri işleyerek üçüncü kişiler tarafından sunulan analiz hizmetleri kapsamında işlenmesi amacıyla sadece bu analiz hizmetlerinin gerektirdiği ölçüde kullanılması amacıyla üçüncü kişilere iletebilecektir. Bahsi geçen teknik iletişim dosyaları, ana bellekte saklanmak üzere Site’nin Veri Sahibi tarayıcısına (browser) gönderdiği küçük metin dosyalarıdır. Teknik iletişim dosyası bir web sitesi hakkında durum ve tercih ayarlarını saklayarak Site’nin kullanımını bu anlamda kolaylaştırır.
 
  
 
 Teknik iletişim dosyası, internet sitelerini zamansal oranlamalı olarak kaç kişinin kullandığını, bir kişinin herhangi bir internet sitesini hangi amaçla, kaç kez ziyaret ettiği ve ne kadar kaldığı hakkında istatistiksel bilgileri elde etmek ve kullanıcılar için özel tasarlanmış kullanıcı sayfalarından dinamik olarak reklam ve içerik üretilmesine yardımcı olmak üzere tasarlanmış olup, bu amaçlarla kullanılmaktadır. Teknik iletişim dosyası, ana bellekten başkaca herhangi bir kişisel veri almak için tasarlanmamıştır. Tarayıcıların pek çoğu başta teknik iletişim dosyasını kabul eder biçimde tasarlanmıştır, ancak kullanıcılar dilerse teknik iletişim dosyasının gelmemesi veya teknik iletişim dosyasının gönderildiğinde ikaz verilmesini sağlayacak biçimde tarayıcı ayarlarını her zaman için değiştirebilirler.
 
  
 
 Verilerinize Kimler Erişebilmektedir?
  
 TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. kişisel verilerinizi ve bu kişisel verileriniz kullanılarak elde edilen yeni verileri, işbu Gizlilik Politikası altında belirtilen amaçların gerçekleştirilebilmesi için restoranlara, söz konusu hizmetlerin temini amacıyla sınırlı olmak üzere aktarılabilecektir. İş ortaklarımıza ve hizmetlerinden faydalandığı tedarikçiler ile üçüncü kişilere anonim veya sınırlı veri aktarımı yapılabilmekle bu durumlarda ayrıca onay alınabilmektedir.
 
  
 
 TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. kullanıcı deneyiminizin geliştirilmesi (iyileştirme ve kişiselleştirme dâhil), güvenliğinizin temin edilmesi, hileli ya da izinsiz kullanımların tespit edilmesi, operasyonel değerlendirme araştırılması, Site hizmetlerine ilişkin hataların giderilmesi ve işbu Gizlilik Politikası’nda yer alan amaçlardan herhangi birisini gerçekleştirebilmek için e-mail ve SMS gönderimi yapanlar da dahil olmak üzere dış kaynak hizmet sağlayıcıları, barındırma hizmet sağlayıcıları (hosting servisleri), hukuk büroları gibi üçüncü kişiler ile paylaşabilecektir.
 
 Veri Sahibi olarak, yukarıda belirtilen amaçlarla sınırlı olmak kaydı ile bahsi geçen üçüncü tarafların kişisel verilerinizi dünyanın her yerindeki sunucularında saklayabileceğini, bu hususa peşinen muvafakat ettiğinizi kabul edersiniz.
 
  
 
 Veri Sahibi olarak, işbu Gizlilik Politikası’na konu bilgilerinizin tam, doğru ve güncel olduğunu, bu bilgilerde herhangi bir değişiklik olması halinde bunları derhal güncelleyeceğinizi taahhüt edersiniz. Güncel bilgileri sağlamamış olmanız halinde TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. herhangi bir sorumluluğu olmayacaktır. Veri Sahibi olarak, herhangi bir kişisel verinizin TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. tarafından kullanılamaması ile sonuçlanacak bir talepte bulunmanız halinde Site’nin veya Mobil uygulamanın işleyişinden tam olarak faydalanamayabileceğini kabul eder ve bu kapsamda doğacak her türlü sorumluluğun size ait olacağını beyan edersiniz.
 
  
 
 Verilerinizi Ne Kadar Süreyle Saklıyoruz?
  
 TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. ile paylaşmış olduğunuz kişisel verileriniz işbu Gizlilik Politikası kapsamında belirtilen amaçların gerektirdiği süre boyunca ve TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. ilgili mevzuatta belirtilen zamanaşımı süreleri boyunca saklanmaktadır.
 
  
 
 Ayrıca, söz konusu kişisel verileriniz TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. ile aranızda doğabilecek herhangi bir uyuşmazlık durumunda, uyuşmazlık kapsamında gerekli savunmaların gerçekleştirilebilmesi amacıyla sınırlı olmak üzere saklanabilecektir.
 
  
 
 Verilerinizin Güvenliğini Nasıl Sağlıyoruz?
  
 
 TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. ilgili mevzuatta belirlenen veya işbu Gizlilik Politikası’nda ifade edilen şartlarda,
 
  
 
 ·         Kişisel verilerin hukuka aykırı olarak işlenmemesini,
 
 ·         Kişisel verilere hukuka aykırı olarak erişilmemesini ve
 
 ·         Kişisel verilerin muhafazasını sağlamak amacıyla uygun şartlar maliyetler gözetilerek/ asgari güvenlik düzeyini temin etmeye yönelik gerekli teknik ve idari tedbirleri almayı, gerekli denetimleri yaptırmaktadır.
 
  
 
 TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. ayrıca, sizden elde ettiği kişisel verileri işbu Gizlilik Politikası ve Kişisel Verilerin Korunması Kanunu hükümlerine aykırı olarak başkasına açıklamamakta ve işleme amacı dışında kullanmamaktadır. Site üzerinden başka uygulamalara link verilmesi halinde, TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. uygulamaların gizlilik politikaları ve içeriklerine yönelik herhangi bir sorumluluk taşımamaktadır ve bu metinleri incelemenizi önermektedir.
 
  
 
 Gizlilik Politikası’ndaki Değişiklikler
  
 İşbu Gizlilik Politikası değişen şartlara ve mevzuata uyum sağlamak amacıyla zaman zaman TAŞIMACIM NAKLİYAT LOJİSTİK ARACILIK HİZMETLERİ LTD. ŞTİ. https://tasimacim.com tarafından güncellenecektir.`}</p>


            </div>

            <Footer />
        </div></>
    }
}